import { useStakingPosition, type StakingPositionStore } from "@/hooks";
import { useMemo } from "react";
import { createColumnHelper, type ColumnDef, type RowData } from "@tanstack/react-table";
import { usePortfolioPositionsTable } from "../usePortfolioPositionsTable";

const stakedColumnHelper = createColumnHelper<StakingPositionStore>();

const stakedColumns: ColumnDef<StakingPositionStore, unknown>[] = [
    stakedColumnHelper.display({ id: "duration", header: "Duration", meta: { widthClass: "w-[10%]" } }),
    stakedColumnHelper.display({ id: "principal", header: "Principal", meta: { widthClass: "w-[30%]" } }),
    stakedColumnHelper.display({
        id: "interest",
        header: "Interest earned",
        meta: { widthClass: "w-[30%]" },
    }),
    stakedColumnHelper.display({ id: "apy", header: "APY", meta: { widthClass: "w-[20%]" } }),
    stakedColumnHelper.display({ id: "actions", header: "Actions", meta: { widthClass: "w-[10%]" } }),
];

export const useStakedPositionsTable = () => {
    const { stakingPosition, isLoading } = useStakingPosition();

    const positionsToDisplay = useMemo(() => (stakingPosition ? [stakingPosition] : []), [stakingPosition]);

    return usePortfolioPositionsTable({
        data: positionsToDisplay,
        columns: stakedColumns,
        isLoading,
    });
};

declare module "@tanstack/react-table" {
    interface ColumnMeta<TData extends RowData, TValue> {
        widthClass?: string;
    }
}
